import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stepOne", "stepTwo"]

  connect() {
    this.reset()
  }

  advance(event) {
    event.preventDefault()
    this.showStep(2)
  }

  back(event) {
    event.preventDefault()
    this.showStep(1)
  }

  reset() {
    this.showStep(1)
  }

  showStep(step) {
    if (!this.hasStepOneTarget || !this.hasStepTwoTarget) return

    const firstStep = step === 1
    this.stepOneTarget.hidden = !firstStep
    this.stepOneTarget.inert = !firstStep
    this.stepTwoTarget.hidden = firstStep
    this.stepTwoTarget.inert = firstStep
  }
}
